import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import GameSelect from '../ui/GameSelect';
import LevelSelect from '../ui/LevelSelect';
import ABCyaLib from '@abcya/abcya_lib';

/**
 * This is your first scene.
 */
export default class Select extends Phaser.Scene {
  static get KEY() { return 'Select'; }

  create() {
    this.cameras.main.setBackgroundColor('#FFFFFF');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.player = ABCyaPhaser.Audio.createSound(this);

    this.checkerHeader = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredHeader', this).setOrigin(0, 0);
    this.checkerFooter = ABCyaPhaser.Images.addImage(0, this.mid.y * 2, 'CheckeredHeader', this).setScale(1, -1)
      .setOrigin(0, 0);

    this.titleContainer = this.add.container();
    this.flagleft = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredFlagIcon', this.titleContainer).setOrigin(0, 0);
    this.flagright = ABCyaPhaser.Images.addImage(0, 0, 'CheckeredFlagIcon', this.titleContainer).setOrigin(0, 0);

    this.titleLabel = this.add.bitmapText(0,0, 'asapBoldItalicSmall', ABCyaPhaser.Localization.instance.getLocalizedString('select.header'), ABCyaLib.Environment.instance.gameConfig.select.titleSize);
    this.titleContainer.add(this.titleLabel);
    this.titleLabel.x = this.flagleft.x + this.flagleft.getBounds().width + 10;
    this.titleLabel.y = this.flagleft.y + this.flagleft.getBounds().height / 2 - this.titleLabel.height / 2;

    this.flagright.x = this.titleLabel.x + this.titleLabel.width + this.flagright.getBounds().width + 10;
    this.flagright.scaleX = -1;

    this.titleContainer.y = this.checkerHeader.getBounds().height + 20;

    this.gameSelect = new GameSelect(this);
    this.gameSelect.on('GAMETYPE_CHANGE', (i) => { this.handleGametypeChange(i); });
    this.gameSelect.x = this.mid.x - this.gameSelect.getBounds().width / 2;

    this.levelSelect = new LevelSelect(this);
    this.levelSelect.x = this.mid.x - this.levelSelect.getBounds().width / 2 - 100; // 20 making up for the whole numbers negative label

    this.btnNext = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BtnNext', null, () => {
      this.btnNext.setEnabled(false);
      this.onClickNext();
    }, this, { disabledTint: '0xFFFFFF' }).setEnabled(false)
      .setOrigin(0, 0);

    this.btnNext.x = this.mid.x * 2 - this.btnNext.getBounds().width;
    this.btnNext.y = this.mid.y * 2 - 200;

    this.layoutRatio();

    this.startTransition();
  }

  layoutRatio() {
    this.gameSelect.y = this.titleContainer.y + this.titleContainer.getBounds().height + 10;
    this.levelSelect.y = this.gameSelect.y + this.gameSelect.getBounds().height + 150;
    this.titleContainer.y = this.checkerHeader.getBounds().height + 20;

    this.btnNext.y = this.mid.y * 2 - 200;
    this.checkerFooter.y = this.mid.y * 2;
  };

  startTransition() {
    ABCyaPhaser.Audio.playOneShot('race_car_drive_by', this);
    ABCyaPhaser.Tweens.addTween(this.titleContainer, 400, { x: this.mid.x * 2 - this.titleContainer.getBounds().width + ABCyaLib.Environment.instance.gameConfig.select.titleX }, Phaser.Math.Easing.Quadratic.Out, () => { this.bringInGameButtons(); });
  };

  bringInGameButtons() {
    ABCyaPhaser.Audio.playOneShot('raceway-04', this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    const wait = this.gameSelect.transitionIn();

    this.time.delayedCall(wait, () => { this.bringInLevelButtons(); });
  };

  bringInLevelButtons() {
    this.levelSelect.transitionIn();
    this.btnNext.setEnabled(true);
  };

  handleGametypeChange(i) {
    if (i === gameData.GAMETYPE_WHOLE_NUMBERS) {
      this.levelSelect.setVisible(true);
    }
    else {
      this.levelSelect.setVisible(false);
    }
  };

  onClickNext() {
    this.sound.stopAll();
    ABCyaPhaser.Audio.playOneShot('click', this);

    gameData.gametype = this.gameSelect.selectedButtonIndex;
    gameData.gamelevel = this.levelSelect.selectedButtonIndex;

    this.scene.start('Questions');
  };
}